export default __webpack_public_path__ + "static/media/todos.a0073f3f.jpg";